import { gsap } from "gsap";
import { useEffect } from "react";

const AboutMe = () => {
  useEffect(() => {
    gsap.to(gsap.utils.toArray(".about-me__description-dimmed h2"), {
      scrollTrigger: {
        trigger: ".about-me__description",
        start: "top 85%",
        end: "center 60%",
        scrub: 2,
      },
      "--clip-size": "100%",
      stagger: 0.7,
    });
  });

  return (
    <section className="about">
      <div className="about-me__heading text-R-normal">about me</div>
      <div className="about-me__description">
        <h2>I’m Avdhesh, an exquisite blend of</h2>
        <h2>designer, developer & animator </h2>
        <h2>with strong focus on producing</h2>
        <h2>impactful digital experiences.</h2>
        <div className="about-me__description-dimmed">
          <h2>I’m Avdhesh, an exquisite blend of</h2>
          <h2>designer, developer & animator </h2>
          <h2>with strong focus on producing</h2>
          <h2>impactful digital experiences.</h2>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
